import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { LocationModel } from 'src/models/locations/location.model';
import { Organisation } from 'src/models/organisation/organisation.model';
import { useRootSelector } from 'src/ui/shared/hooks/root-selector.hook';
import { LocationSingleControl } from './LocationSingleControl';

type RelevantFields = Pick<
    Organisation,
    'city' | 'countryCode' | 'street' | 'region' | 'postcode' | 'geolocation'
>;

interface Props {
    defaultValue: LocationModel | undefined;
}

export const OrganisationLocationSingleControl = ({ defaultValue }: Props): React.ReactElement => {
    const defaultCountryCode = useRootSelector(state => state.configuration.value.countryCode);
    const { setValue, getValues } = useFormContext<RelevantFields>();

    const onChange = useCallback(
        (data: LocationModel) => {
            const currentValue = getValues();

            Object.keys(data).map(key => {
                const keyAs = key as keyof LocationModel;
                // this is a hack, anytime I need to compare values I'm going something wrong
                if (currentValue[keyAs] !== data[keyAs]) {
                    setValue(keyAs, data[keyAs]);
                }
            });
        },
        [getValues, setValue]
    );

    return (
        <>
            <div className="mb-1">Location</div>
            <LocationSingleControl
                name="organisation-location"
                onChange={onChange}
                defaultCountryCode={defaultCountryCode}
                defaultValue={defaultValue}
            />
        </>
    );
};
